module.exports = __webpack_public_path__ + "img/bottom_chat_bar_l_img.ee092cbd.png";